const en = {
  hello: 'hello',
  town: { label: 'Town' },
  portal: { label: 'Portal' },
  home: { label: 'Home' },
  picture: { label: 'Picture' },
  name: { label: 'Name' },
  position: { label: 'Position' },
  contact: { label: 'Contact' },
  contributor: { label: 'Contributor' },
  modifiedDate: { label: 'Modified Date' },
  galleryImage: { label: 'Gallery Image' },
  linkImage: { label: 'Link Image' },
  profileImage: { label: 'Profile Image' },
  default: {
    title: { label: 'Title' },
    seq: { label: 'No.' },
  },
  alert: {
    deleteImage: { label: 'Are you sure delete image ?' },
  },
  actions: {
    create: { label: 'Create' },
    save: { label: 'Save' },
    delete: { label: 'Delete' },
    copy: { label: 'Copy' },
    add: { label: 'Add' },
    edit: { label: 'Edit' },
    search: { label: 'Search' },
    replace: { label: 'Replace' },
    clear: {label: 'Clear'},
    uploadImage: { label: 'Upload Image' },
  },
  info: {
    label: 'Information',
    title: {
      label: 'Title',
      placeholder: 'Enter your title',
    },
    description: {
      label: 'Description',
      placeholder: 'Enter your description',
    },
    tags: {
      label: 'Tags',
      placeholder: 'Enter your tags',
    },
    shortDescription: {
      label: 'Short Description',
      placeholder: 'Enter your short description',
    },
    highlightSentence: {
      label: 'Highlight Sentence',
      placeholder: 'Enter your highlight sentence',
    },
    editorNotes: {
      label: 'Editor Notes',
      placeholder: 'Enter your editor notes',
    },
    openingHours: {
      label: 'Opening Hours',
      placeholder: 'Enter your opening hours',
    },
    location: {
      streetAddress: {
        label: 'Street Address',
      },
    },
  },
  contacts: {
    label: 'Contacts',
    email: {
      label: 'Email',
      placeholder: 'Enter your email',
    },
    phone: {
      label: 'Phone',
      placeholder: 'Enter your phone',
    },
    fanpage: {
      label: 'Fanpage',
      placeholder: 'Enter your fanpage',
    },
    fbPageId: {
      label: 'Page ID',
      placeholder: 'Enter your Page ID for Customer Chat',
    },
    messengerId: {
      label: 'Messenger Id',
      placeholder: 'Messenger ID',
    },
    lineId: {
      label: 'LineId',
      placeholder: 'Enter your lineID',
    },
    instragramId: {
      label: 'InstragramId',
      placeholder: 'Enter your instragramID',
    },
    webpage: {
      label: 'Webpage',
      placeholder: 'Enter your webpage',
    },
    others: {
      label: 'Others',
      placeholder: 'Enter your others',
    },
  },
  place: {
    label: 'Place',
    latitude: {
      label: 'Latitude',
      placeholder: 'latitude',
    },
    longitude: {
      label: 'Longitude',
      placeholder: 'ใส่่ลองจิจูด',
    },
    streetAddress: {
      label: 'Street Address',
      placeholder: 'streetAddress',
    },
    currentPosition: {
      label: 'Current position',
    },
  },
  imageManagement: { label: 'Image Management' },
  export: { label: 'Export' },
}
export default en



// WEBPACK FOOTER //
// ./src/modules/i18n/resources/en.js